import scrollTo from './scrollTo';

const sectionJumper = $('.js-section-skip');

sectionJumper.on('click', event => {
  try {
    event.preventDefault();
    const target = $('.features-home');
    scrollTo(target, 350);
  } catch (e) {}
});
